import Rollbar from "rollbar";

let rollbar = new Rollbar({
  accessToken: "bc1976c0b06a4fb2b1fb24c564d58c34",
  captureUncaught: true,
  captureUnhandledRejections: true
});

export default rollbar;
